export const GET_BOARDS = 'GET_BOARDS' as const;
export const GET_BOARDS_PENDING = 'GET_BOARDS_PENDING' as const;
export const GET_BOARDS_FULFILLED = 'GET_BOARDS_FULFILLED' as const;
export const GET_BOARDS_REJECTED = 'GET_BOARDS_REJECTED' as const;
export const GET_BOARD_INFO = 'GET_BOARD_INFO' as const;
export const GET_BOARD_INFO_PENDING = 'GET_BOARD_INFO_PENDING' as const;
export const GET_BOARD_INFO_FULFILLED = 'GET_BOARD_INFO_FULFILLED' as const;
export const GET_BOARD_INFO_REJECTED = 'GET_BOARD_INFO_REJECTED' as const;
export const GET_BOARD_TRENDS = 'GET_BOARD_TRENDS' as const;
export const GET_BOARD_TRENDS_PENDING = 'GET_BOARD_TRENDS_PENDING' as const;
export const GET_BOARD_TRENDS_FULFILLED = 'GET_BOARD_TRENDS_FULFILLED' as const;
export const GET_BOARD_TRENDS_REJECTED = 'GET_BOARD_TRENDS_REJECTED' as const;
export const GET_BOARD_ARTICLES = 'GET_BOARD_ARTICLES' as const;
export const GET_BOARD_ARTICLES_PENDING = 'GET_BOARD_ARTICLES_PENDING' as const;
export const GET_BOARD_ARTICLES_FULFILLED = 'GET_BOARD_ARTICLES_FULFILLED' as const;
export const GET_BOARD_ARTICLES_REJECTED = 'GET_BOARD_ARTICLES_REJECTED' as const;
export const GET_BOARD_HOT_ARTICLES = 'GET_BOARD_HOT_ARTICLES' as const;
export const GET_BOARD_HOT_ARTICLES_PENDING = 'GET_BOARD_HOT_ARTICLES_PENDING' as const;
export const GET_BOARD_HOT_ARTICLES_FULFILLED = 'GET_BOARD_HOT_ARTICLES_FULFILLED' as const;
export const GET_BOARD_HOT_ARTICLES_REJECTED = 'GET_BOARD_HOT_ARTICLES_REJECTED' as const;
export const GET_BOARD_TOP_USERS = 'GET_BOARD_TOP_USERS' as const;
export const GET_BOARD_TOP_USERS_PENDING = 'GET_BOARD_TOP_USERS_PENDING' as const;
export const GET_BOARD_TOP_USERS_FULFILLED = 'GET_BOARD_TOP_USERS_FULFILLED' as const;
export const GET_BOARD_TOP_USERS_REJECTED = 'GET_BOARD_TOP_USERS_REJECTED' as const;
export const GET_BOARD_USER_COUNT = 'GET_BOARD_USER_COUNT' as const;
export const GET_BOARD_USER_COUNT_PENDING = 'GET_BOARD_USER_COUNT_PENDING' as const;
export const GET_BOARD_USER_COUNT_FULFILLED = 'GET_BOARD_USER_COUNT_FULFILLED' as const;
export const GET_BOARD_USER_COUNT_REJECTED = 'GET_BOARD_USER_COUNT_REJECTED' as const;
